import { render, staticRenderFns } from "./screen-icon-info.vue?vue&type=template&id=156723ea&"
import script from "./screen-icon-info.vue?vue&type=script&lang=js&"
export * from "./screen-icon-info.vue?vue&type=script&lang=js&"
import style0 from "./screen-icon-info.vue?vue&type=style&index=0&id=156723ea&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports